export default (errors: Array<any>, context: any) => {}
